function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLight610X610Px = function SvgLight610X610Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 610 610",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m342.7 18.8 256 266.4c15.3 15.9 14.6 41-1.6 56.1l-271 251.8c-16.2 15-41.7 14.3-57-1.6l-256-266.4c-15.3-15.9-14.6-41 1.6-56.1l271-251.8c16.2-15 41.7-14.3 57 1.6",
    style: {
      fill: "#f0f4f9"
    }
  }));
};
export default SvgLight610X610Px;